/* eslint-disable react/no-array-index-key */
import React from 'react'

// Components
import NavLink from 'components/shared/NavLink'
import Submenu from 'components/layout/Header/Submenu'

// Images
import Chevron from 'img/chevron.inline.svg'

// Third Party
import styled, { css } from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'
import ButtonPrimary from 'components/elements/Buttons/ButtonPrimary'
import ParseContent from 'components/shared/ParseContent'

const Item = styled(motion.li)`
  & > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  & div > a {
    color: ${(props) => props.theme.color.primary};
    font-weight: ${({ theme }) => theme.font.weight.light};

    &[aria-current] {
    }

    &:hover {
      opacity: 0.7;
    }
    @media (max-width: 1199px) {
      font-size: 16px !important;
      & > div {
        font-size: 16px !important;
      }
    }
  }

  @media (min-width: 1400px) {
    margin-right: 70px;
  }
  @media (max-width: 1399px) {
    margin-right: 40px;
  }
  @media (max-width: 1199px) {
    margin-right: 20px;
  }

  @media screen and (max-width: 991px) {
    padding: 4px 0;

    & div > a {
      font-size: 22px;
      line-height: 22px;
      font-weight: ${({ theme }) => theme.font.weight.bold};
    }
  }
`

interface MenuProps {
  fields: GatsbyTypes.WpComponent
}

const SvgWrapper = styled.div<{ open: boolean }>`
  margin-left: 10px;
  transform: rotate(90deg);

  & > svg {
    transition: all 0.3s ease;

    ${({ open }) =>
      open
        ? css`
            transform: rotate(180deg);
          `
        : css`
            transform: rotate(0deg);
          `};
  }
`

const Menu: React.FC<MenuProps> = ({ fields }) => {
  const [open, setOpen] = React.useState<number>(-1)

  const { menu }: any = fields.header?.menuHeader

  const { cta }: any = fields.header?.menuHeader

  return (
    <>
      {menu?.map((l: any, index: number) => (
        <>
          <Item
            onHoverStart={() => setOpen(index)}
            onHoverEnd={() => setOpen(-1)}
            // onTap={open === index ? () => setOpen(-1) : () => setOpen(index)}
            key={index}
            className="py-lg-5"
          >
            <div>
              <NavLink to={l?.link?.url || '/'}>
                <ParseContent content={l?.link?.title} />
              </NavLink>
              {l?.submenu.menu && (
                <SvgWrapper
                  onClick={
                    open === index ? () => setOpen(-1) : () => setOpen(index)
                  }
                  open={open === index}
                >
                  <Chevron />
                </SvgWrapper>
              )}
            </div>
            {l?.submenu.menu && (
              <AnimatePresence>
                {open === index && <Submenu fields={l.submenu} />}
              </AnimatePresence>
            )}
          </Item>
        </>
      ))}
      <div
        className="d-lg-flex d-none"
        style={{ minWidth: 267, display: 'flex', justifyContent: 'flex-end' }}
      >
        <ButtonPrimary to={cta.url}>{cta.title}</ButtonPrimary>
      </div>
    </>
  )
}

export default Menu
